/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sponsor_Edit_NoneInputs */



/**
* | output |
* | --- |
* | "No sponsor recorded" |
*
* @param {Sponsor_Edit_NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sponsor_edit_none = /** @type {((inputs?: Sponsor_Edit_NoneInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sponsor_Edit_NoneInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun parrain enregistré")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ningún avalista registrado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum padrinho registrado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuno sponsor registrato")
	return /** @type {LocalizedString} */ ("No sponsor recorded")
});